import React, { useEffect, useRef } from 'react';
import './aboutus.css';

import largeImg from "../../assets/logo.jpg";
import associationlogoImg1 from "../../assets/tvec-logo.png";
import associationlogoImg2 from "../../assets/iso-logo.png";
import associationlogoImg3 from "../../assets/ccoo-logo.png";
import associationlogoImg4 from "../../assets/wco-logo.png";
import associationlogoImg5 from "../../assets/apcoo-logo.png";
import associationlogoImg6 from "../../assets/tvec-qms.png";

const logos = [
  { src: associationlogoImg1, alt: 'Association Logo 1' },
  { src: associationlogoImg2, alt: 'Association Logo 2' },
  { src: associationlogoImg3, alt: 'Association Logo 3' },
  { src: associationlogoImg4, alt: 'Association Logo 4' },
  { src: associationlogoImg5, alt: 'Association Logo 5' },
  { src: associationlogoImg6, alt: 'Association Logo 6' },
];

function WhoWeAre() {
  const logosContainerRef = useRef(null);

  useEffect(() => {
    const logosContainer = logosContainerRef.current;
    if (!logosContainer) return;

    // Duplicate the logos for seamless scrolling
    const originalLogos = logosContainer.innerHTML; // Store the original content
    logosContainer.innerHTML += originalLogos; // Duplicate it for seamless scrolling

    const animateScroll = () => {
      const scrollWidth = logosContainer.scrollWidth / 2; // Calculate the width of original content
      if (logosContainer.scrollLeft >= scrollWidth) {
        logosContainer.scrollLeft = 0; // Reset to the start for seamless loop
      } else {
        logosContainer.scrollLeft += 1; // Adjust speed here
      }
      requestAnimationFrame(animateScroll);
    };

    animateScroll();
  }, []);

  return (
    <div className="who-we-are-container">


      <div className="who-we-are-header">
        <div className="who-we-are-header-content">
          <div className="who-we-are-text">
            <h1>Who We Are</h1>
                <p>
                  Founded in 2007 as a School of Optometry, the Eye Care Institute (ECI) has grown into a leading non-state higher education institution dedicated to advancing eye care education in Sri Lanka.
                  </p>

                  <p>
                  In response to the evolving landscape of modern optometric practice, ECI has continually expanded its curriculum and clinical programmes not only within the institute itself, but across all levels of the eye care sector.
                  </p>

                  <p>
                  Today, we offer a range of recognised Optician and Optometry programmes designed to meet national and international demand. Approved by the Ministry of Education and accredited by the Tertiary & Vocational Education Commission (TVEC), ECI is proud to be the first private Optometry institute in Sri Lanka recognised by the Government.
                  </p>

                  <p>
                  We are also the only Optometry institute in the country affiliated with a university. Our international standing is further affirmed by our membership in the World Council of Optometry (WCO) and the Asia Pacific Council of Optometry (APCO), while our programmes are locally recognised by the Ceylon Council of Optometrists & Orthoptists (CCOO), Sri Lanka.
                  </p>
          
          </div>
          <img src={largeImg} alt="Eye Care Institute Symbol" className="symbol-image" />
        </div>
      </div>







      <div className="program-details p-4 bg-gray-100 rounded-lg shadow-md">
      <h2 className="text-xl font-bold text-blue-700 mb-4">About Eye Care Institute</h2>
      <ul className="list-disc pl-5 space-y-2 text-gray-700">
        <li>Eye Care Institute was founded in 2007 as a school of Optometry.</li>
        <li>Eye Care Institute is the first private Optometry college recognized by the government of Sri Lanka.</li>
        <li>
          Accredited & Registered with the Tertiary & Vocational Education Commission (TVEC), Ministry of Education Sri Lanka
          since 2010, bearing Registration number P/01 0488.
        </li>
        <li>
          Eye Care Institute is the first institute affiliated with a university, leading the diploma in optometry to BOptom and
          ultimately to Doctorate in Optometry (OD).
        </li>
        <li>
          Ceylon Eye Care Optometric Association is the optometric association of The Eye Care Institute, incorporated as a
          non-profit organization bearing Reg. No. G A 2572.
        </li>
        <li>Community eye care services are associated programs of Eye Care Institute to provide eye care services for underprivileged public.</li>
        <li>
          Lions Club of Colombo Eye Care and Leo Club of Colombo Eye Care are the first specialized LIONS & LEO clubs in Sri Lanka.
        </li>
        <li>Eye Care Institute is a member of the World Council Of Optometry (WCO) & Asia Pacific Council of Optometry (APCO).</li>
        <li>
          Ceylon Eye Care Optometric Association is a partner organization of the Ceylon Council of Optometrists & Orthoptists.
        </li>
        <li>Eye Care Institute is the only QMS 9001:2008 certified institute in Sri Lanka.</li>
        <li>Optica - The Eye Care Network is the largest network associated with Eye Care Institute.</li>
      </ul>
    </div>








      <div className="accreditation">
        <h2>Accreditation</h2>
        <p>
        The first private optometry college recognized by the government of Sri Lanka. Since 2009, the Eye Care Institute has been registered and accredited by the Tertiary & Vocational Education Commission (TVEC), Ministry of Education under registration number P/01 0488. Additionally, the institute is the only QMS 9001:2008 certified eye care training institute in Sri Lanka. The institute also holds memberships with the World Council of Optometry (WCO), Ceylon Council of Optometry and Orthoptics (CCOO), and Asia Pacific Council of Optometry (APCO).
      
          The Eye Care Institute is proudly affiliated with SEGi University in Malaysia, one of the top-ranking universities in the region. 
        </p>
      </div>

      <div className="vision-mission">
        <div className="vision">
          <h2>Our Vision</h2>
          <p>
            To be the leader in professional eye care organizations by enhancing the quality and quantity of service providers across all segments of eye care in the region.
          </p>
        </div>
        <div className="mission">
          <h2>Our Mission</h2>
          <p>
            To improve the quality of life in the region by integrating, sharing, and enhancing experience and innovation with professionals involved in eye care.
          </p>
        </div>
      </div>

      <div className="logo-container" ref={logosContainerRef}>
        {logos.map((logo, index) => (
          <img key={index} src={logo.src} alt={logo.alt} height="100" width="120" />
        ))}
      </div>
    </div>
  );
}

export default WhoWeAre;
